import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Divider,
    Select,
    Form as FormInitial,
    Tooltip,
} from "antd";
import { CalculatorOutlined } from "@ant-design/icons";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    NotificacionPolizas,
    NotificacionMovimientosInventario,
    ButtonItem,
    ErrorItem,
    calcularMaxDisponible
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import EnviarCorreoApartarVenta from "./EnviarCorreoApartarVenta/EnviarCorreoApartarVenta";

const { Option } = Select;

moment.locale("es");

class ApartarInsumosVenta extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        datosVenta: undefined,
        todasInsumos: null,
        objetoInsumos: null,
        todasProyectos: null,
        objetoProyectos: null,
        id: this.props.location.state.ventaId,
        modalElegirLotes: false,
        modalElegirLotesIndex: null,
        modalElegirLotesLotes: null,
        modalElegirLotesInsumoId: null,
        modalElegirLotesProyectoId: null,
        modalElegirLotesClienteId: null,
        modalElegirLotesCantidad: null,
        modalCorreoApartado: false,
        insumosApartadosParaPdf: [],
    };
    componentDidMount() {
        this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "ventas/datosVentaPRecibirP",
                {
                    empresaId: this.props.empresaId,
                    ventaId: this.state.id,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then(async (res) => {
                if (res.data.success === 2) {
                    this.setState({
                        datosVenta: res.data.venta,
                        todasInsumos: res.data.insumos,
                        todasProyectos: res.data.proyectos,
                        objetoInsumos: res.data.insumos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.stringBuscar}
                                </Option>
                            );
                        }),
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                    const insumosFormato = res.data.venta.insumos.map(value => {
                        return { ...value, precioUnitarioAjustado: (value.precioUnitario * (1 - (value.descuento / 100))), apartado: value.apartado || 0 }
                    });
                    this.formRef.current.setFieldsValue({ insumos: insumosFormato });

                    // Consulta de inventarios en bulk
                    const insumosBulk = insumosFormato.map((row, index) => {
                        const insumoOriginal = res.data.insumos.find(i => i._id.toString() === row.insumoId.toString());
                        return {
                            index,
                            insumoId: row.insumoId,
                            proyectoId: row.proyectoId,
                            inventariable: insumoOriginal?.inventariable,
                            noPrincipal: insumoOriginal?.noPrincipal,
                            insumoCompuesto: insumoOriginal?.insumoCompuesto,
                            componentesKit: row.componentesKit,
                        };
                    });
                    try {
                        const resInventarios = await axios.post(
                            "inventarios/inventarioInsumoProyectoBulk",
                            { empresaId: this.props.empresaId, insumos: insumosBulk },
                            { headers: this.props.headersToken }
                        );
                        if (resInventarios.data?.results) {
                            resInventarios.data.results.forEach(r => {
                                insumosFormato[r.index].cantidadProyecto = r.cantidad !== null ? r.cantidad : "No inventariable";
                            });
                            this.formRef.current.setFieldsValue({ insumos: insumosFormato });
                        }
                    } catch (e) {
                        console.error("Error al consultar inventario bulk", e);
                    }
                } else {
                    message.error(
                        "Error no se encontro informacion de la venta"
                    );
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        let apartarTodos = 0;
        values.insumos = values.insumos.map(value => {
            let apartar = value.apartar ? value.apartar : 0
            apartarTodos += apartar
            return { ...value, apartar }
        })
        if (apartarTodos === 0) return message.info('Se neceitan cantidades para poder hacer esta operación')
        this.setState({ loading: true });
        axios
            .post(
                "ventas/apartarInsumos",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    ventaId: this.state.id,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se apartaron los insumos");
                    NotificacionPolizas(res.data.polizasId);
                    NotificacionMovimientosInventario(res.data.movimientosIds);
                    this.formRef.current.resetFields();

                    // Preparar insumos para el PDF
                    const insumosApartadosParaPdf = values.insumos
                        .filter(i => i.apartar > 0)
                        .map(i => {
                        const insumo = this.state.todasInsumos.find(t => t._id === i.insumoId);
                        return {
                            insumoId: i.insumoId,
                            clave: insumo?.clave || insumo?.codigo || '',
                            descripcion: insumo?.descripcion || '',
                            apartar: i.apartar,
                        };
                        });

                    this.setState({ modalCorreoApartado: true, insumosApartadosParaPdf });
                } else if (res.data.success === 1) {
                    message.error(res.data.message ? res.data.message : "No se pueden apartar los insumos");
                } else {
                    // El backend manda el texto del catalogo de inventario ("Un lote a
                    // descontar no hay cantidad suficiente", etc.) tambien en success 0.
                    message.error(res.data.message ? res.data.message : "Hubo un error y no se apartaron los insumos");
                }
            });
    }
    atras() {
        this.props.history.goBack();
    }
    setMaxApartarTodos = async () => {
        const form = this.formRef?.current;
        if (!form) return;
        this.setState({ loading: true });

        const insumos = form.getFieldValue("insumos") || [];

        const maxPorFila = insumos.map((row, idx) => {
            const fila = this.state?.datosVenta?.insumos?.[idx];
            return calcularMaxDisponible({
                cantidad: fila?.cantidad,
                yaMovido: Math.max(Number(fila?.apartado) || 0, Number(fila?.entregado) || 0),
                cantidadProyecto: row?.cantidadProyecto,
            });
        });

        const insumosConLotes = insumos
            .map((row, idx) => {
                const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
                if (!insumo?.lotesCaducidades || maxPorFila[idx] <= 0) return null;
                return { insumoId: row.insumoId, proyectoId: row.proyectoId, cantidad: maxPorFila[idx], _idx: idx };
            })
            .filter(Boolean);

        let resultadosMap = {};
        if (insumosConLotes.length > 0) {
            try {
                const res = await axios.post(
                    "lotes/selectLotesDiponiblesMasivoRecomendado",
                    {
                        empresaId: this.props.empresaId,
                        insumos: insumosConLotes.map(({ insumoId, proyectoId, cantidad, _idx }) => ({ insumoId, proyectoId, cantidad, idx: _idx })),
                    },
                    { headers: this.props.headersToken }
                );
                if (res.data.success === 2) {
                    res.data.resultados.forEach((r) => {
                        resultadosMap[r.idx] = r;
                    });
                }
            } catch (e) {
                // Si falla, seguimos sin lotes automáticos
            }
        }

        const nuevos = insumos.map((row, idx) => {
            const resultado = resultadosMap[idx];
            let apartar = maxPorFila[idx];
            let extra = {};
            if (resultado) {
                apartar = Number(Math.min(apartar, resultado.cantidadCubierta));
                extra = { lotes: resultado.lotes };
            }
            return { ...row, apartar, ...extra };
        });

        form.setFieldsValue({ insumos: nuevos });
        this.setState({ loading: false });
    };
    async onChangeInsumoProyecto(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
        );
        if (!insumo) return
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        componentesKit: arrayValue[key].componentesKit,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
        const clienteId = this.state.datosVenta?.cliente?._id
        if (proyectoId) {
            this.setState({
                modalElegirLotes: true,
                modalElegirLotesIndex: value,
                modalElegirLotesLotes: lotes || [],
                modalElegirLotesInsumoId: insumoId,
                modalElegirLotesProyectoId: proyectoId,
                modalElegirLotesClienteId: clienteId,
                modalElegirLotesCantidad: cantidad,
            })
        } else {
            message.warning('Elegir un proyecto para elegir lotes')
        }
    }
    cerrarElegirLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirLotesIndex].lotes = value
        this.formRef.current.setFieldsValue({ insumos })
        this.setState({
            modalElegirLotes: false,
            modalElegirLotesIndex: null,
            modalElegirLotesLotes: null,
            modalElegirLotesInsumoId: null,
            modalElegirLotesProyectoId: null,
            modalElegirLotesClienteId: null,
            modalElegirLotesCantidad: null,
        })
    }
    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Apartar Insumos sobre Venta"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <h1>
                            Fecha:{" "}
                            {moment(this.state.datosVenta?.createdAt).format("LL")}
                        </h1>
                    }
                />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="apartarInsumosFactura"
                            layout
                            bottom={
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Apartar
                                </ButtonItem>
                            }
                            onFinish={this.onFinish.bind(this)}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Row >
                                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                                    <h1 style={{ margin: 0 }}>
                                        Proyecto: {this.state.datosVenta?.proyecto.nombre}
                                    </h1>
                                    <p>
                                        Descripcion:{" "}
                                        {this.state.datosVenta?.proyecto.descripcion}
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                                    <h1 style={{ margin: 0 }}>Dirección</h1>
                                    {this.state.datosVenta?.proyecto.calle ? (
                                        <>
                                            <p style={{ margin: 0 }}>
                                                Calle: {this.state.datosVenta?.proyecto.calle}
                                            </p>
                                            <p style={{ margin: 0 }}>
                                                Numero:{" "}
                                                {this.state.datosVenta?.proyecto.numeroCalle}
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{ margin: 0 }}>
                                                Marca: {this.state.datosVenta?.proyecto.marca}
                                            </p>
                                            <p style={{ margin: 0 }}>
                                                Modelo: {this.state.datosVenta?.proyecto.modelo}
                                            </p>
                                            <p style={{ margin: 0 }}>
                                                Placas: {this.state.datosVenta?.proyecto.placas}
                                            </p>
                                        </>
                                    )}
                                </Col>
                                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                                    <h1 style={{ margin: 0 }}>
                                        Cliente:{" "}
                                        {this.state.datosVenta?.cliente.nombre
                                            ? this.state.datosVenta?.cliente.nombre +
                                            " " +
                                            this.state.datosVenta?.cliente
                                                .apellidoPaterno +
                                            " " +
                                            this.state.datosVenta?.cliente.apellidoMaterno
                                            : this.state.datosVenta?.cliente.razonSocial}
                                    </h1>
                                    <p style={{ margin: 0 }}>
                                        Rfc: {this.state.datosVenta?.cliente.rfc}
                                    </p>
                                    <p style={{ margin: 0 }}>
                                        Correo: {this.state.datosVenta?.cliente.correo}
                                    </p>
                                    <p style={{ margin: 0 }}>
                                        Telefono:{" "}
                                        {this.state.datosVenta?.cliente.telefono}
                                    </p>
                                    <p style={{ margin: 0 }}>
                                        Celular: {this.state.datosVenta?.cliente.celular}
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                                    <p style={{ margin: 0 }}>
                                        Contacto:{" "}
                                        {this.state.datosVenta?.cliente.nombreContacto}
                                    </p>
                                    <p style={{ margin: 0 }}>
                                        Tel. Contacto:{" "}
                                        {this.state.datosVenta?.cliente.telefonoContacto}
                                    </p>
                                    <p style={{ margin: 0 }}>
                                        Correo Contacto:{" "}
                                        {this.state.datosVenta?.cliente.correoContacto}
                                    </p>
                                    <p style={{ margin: 0 }}>
                                        Dias de crédito:{" "}
                                        {this.state.datosVenta?.cliente.diasCredito}
                                    </p>
                                </Col>
                            </Row>
                            <Divider style={{ marginBottom: 10, marginTop: 5 }} />
                            <FormInitial.List name="insumos">
                                {(fields) => (
                                    <>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                                                {fields.length > 0 ? (
                                                    <thead>
                                                        <tr>
                                                            <th className="th-border" style={{ width: "30%" }}>
                                                                Insumo
                                                            </th>
                                                            <th className="th-border" style={{ width: "20%" }}>
                                                                Proyecto
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Cantidad Proyecto
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Cantidad Pedida
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Apartado
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%", textAlign: "center" }}>
                                                                Cantidad a apartar
                                                                <Tooltip title="Poner máximos">
                                                                    <CalculatorOutlined onClick={this.setMaxApartarTodos} style={{ marginLeft: 5, color: 'green', cursor: 'pointer' }} />
                                                                </Tooltip>
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Accion
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                ) : null}
                                                {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                                                    <FormItem key={fieldKey} noStyle shouldUpdate>
                                                        {({ getFieldValue }) => {
                                                            const row = (getFieldValue('insumos') || [])[arrayKey];
                                                            const lotes = row?.lotes || [];
                                                            const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
                                                            const necesitaLotes = insumo?.lotesCaducidades;
                                                            const apartar = row?.apartar || 0;
                                                            const sumLotes = lotes.reduce((s, l) => s + (l.cantidadRequerida || 0), 0);
                                                            const isRed = necesitaLotes && apartar > 0 && sumLotes !== apartar;
                                                            return (
                                                    <tbody>
                                                        <tr style={isRed ? { backgroundColor: '#ffccc7' } : {}}>
                                                            <td className="td-border">
                                                                <FormItem
                                                                    {...restField}
                                                                    name={[name, "insumoId"]}
                                                                    fieldKey={[fieldKey, "insumoId"]}
                                                                    required
                                                                    noStyle
                                                                >
                                                                    <SelectItem
                                                                        sinBorde
                                                                        style={{ width: "100%" }}
                                                                        placeholder="Insumo"
                                                                        disabled
                                                                    >
                                                                        {this.state.objetoInsumos}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </td>
                                                            <td className="td-border">
                                                                <FormItem
                                                                    {...restField}
                                                                    name={[name, "proyectoId"]}
                                                                    fieldKey={[fieldKey, "proyectoId"]}
                                                                    required
                                                                    noStyle
                                                                >
                                                                    <SelectItem
                                                                        sinBorde
                                                                        style={{ width: "100%" }}
                                                                        placeholder="Proyecto"
                                                                        onChange={(value) =>
                                                                            this.onChangeInsumoProyecto(
                                                                                value,
                                                                                arrayKey
                                                                            )
                                                                        }
                                                                    >
                                                                        {this.state.objetoProyectos}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </td>
                                                            <td className="td-border">
                                                                <FormItem
                                                                    {...restField}
                                                                    name={[name, "cantidadProyecto"]}
                                                                    required
                                                                    noStyle
                                                                >
                                                                    <InputNumberItem
                                                                        sinBorde
                                                                        disabled
                                                                        placeholder="Cantidad en Proyecto"
                                                                    />
                                                                </FormItem>
                                                            </td>
                                                            <td className="td-border">
                                                                <FormItem
                                                                    {...restField}
                                                                    name={[name, "cantidad"]}
                                                                    fieldKey={[fieldKey, "cantidad"]}
                                                                    required
                                                                    number
                                                                    noStyle
                                                                >
                                                                    <InputNumberItem
                                                                        sinBorde
                                                                        placeholder="Cantidad Vendida"
                                                                        disabled
                                                                    />
                                                                </FormItem>
                                                            </td>
                                                            <td className="td-border">
                                                                <FormItem
                                                                    {...restField}
                                                                    name={[name, "apartado"]}
                                                                    fieldKey={[fieldKey, "apartado"]}
                                                                    required
                                                                    numberCero
                                                                    noStyle
                                                                    initialValue={0}
                                                                >
                                                                    <InputNumberItem
                                                                        sinBorde
                                                                        placeholder="Cantidad Entregada"
                                                                        disabled
                                                                    />
                                                                </FormItem>
                                                            </td>
                                                            <td className="td-border">
                                                                <FormItem shouldUpdate noStyle>
                                                                    {({ getFieldValue }) => {
                                                                        // arrayKey en ambas lecturas: antes la venta se indexaba
                                                                        // con fieldKey y cantidadProyecto con arrayKey. Hoy
                                                                        // coinciden, pero son dos indices distintos de Form.List.
                                                                        const filaVenta = this.state.datosVenta?.insumos?.[arrayKey];
                                                                        const insumos = getFieldValue("insumos");
                                                                        const maxDisabled = calcularMaxDisponible({
                                                                            cantidad: filaVenta?.cantidad,
                                                                            yaMovido: Math.max(
                                                                                Number(filaVenta?.apartado) || 0,
                                                                                Number(filaVenta?.entregado) || 0
                                                                            ),
                                                                            cantidadProyecto: insumos?.[arrayKey]?.cantidadProyecto,
                                                                        });
                                                                        return (
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "apartar"]}
                                                                                fieldKey={[fieldKey, "apartar"]}
                                                                                numberCero
                                                                                noStyle
                                                                                max={maxDisabled}
                                                                                type="number"
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    placeholder={"Max: " + maxDisabled}
                                                                                />
                                                                            </FormItem>
                                                                        );
                                                                    }}
                                                                </FormItem>
                                                            </td>
                                                            <td className="td-border">
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <FormItem noStyle shouldUpdate>
                                                                            {({ getFieldValue }) => {
                                                                                let arrayValue = getFieldValue("insumos");
                                                                                let mostrarLotes = false
                                                                                let insumoId
                                                                                let proyectoId
                                                                                if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                                                                    const insumo = this.state.todasInsumos.find(
                                                                                        (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                                                                    );
                                                                                    mostrarLotes = insumo?.lotesCaducidades
                                                                                    insumoId = insumo?._id
                                                                                    proyectoId = arrayValue[arrayKey]?.proyectoId
                                                                                }
                                                                                if (mostrarLotes) {
                                                                                    return (
                                                                                        <ButtonItem
                                                                                            type="primary"
                                                                                            size='small'
                                                                                            style={{ width: '80%', marginLeft: '10%' }}
                                                                                            block
                                                                                            onClick={() => {
                                                                                                this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].apartar)
                                                                                            }}
                                                                                        >
                                                                                            {this.props.taxidermia ? "Animales" : "Lotes"}
                                                                                        </ButtonItem>
                                                                                    )
                                                                                }
                                                                            }}
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                            );
                                                        }}
                                                    </FormItem>
                                                ))}
                                            </table>
                                        </div>
                                    </>
                                )}
                            </FormInitial.List>
                        </Form>
                    </Spin>
                </div>
                <ElegirLotes
                    visible={this.state.modalElegirLotes}
                    cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
                    lotes={this.state.modalElegirLotesLotes}
                    insumoId={this.state.modalElegirLotesInsumoId}
                    proyectoId={this.state.modalElegirLotesProyectoId}
                    clienteId={this.state.modalElegirLotesClienteId}
                    ventaId={this.state.id}
                    cantidad={this.state.modalElegirLotesCantidad}
                    modoCantidad="exacta"
                />
                <EnviarCorreoApartarVenta
                    visible={this.state.modalCorreoApartado}
                    id={this.state.id}
                    insumosApartados={this.state.insumosApartadosParaPdf}
                    cerrarModal={() => {
                        this.setState({ modalCorreoApartado: false });
                        this.atras();
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ApartarInsumosVenta);
